export const genderList = () => [
  { label: "Chọn giới tính", value: "" },
  { label: "Nam", value: "Nam" },
  { label: "Nữ", value: "Nữ" },
  { label: "Khác", value: "Khác" },
];

export const routes = [
  {
    title: "Quản lý từ vựng",
    desc: "Quản lý từ vựng",
    icon: "📚",
    to: "jisho-words",
    gradient: "from-gray-500 to-gray-500",
  },
  {
    title: "Quản lý đoạn văn",
    desc: "Quản lý đoạn văn",
    icon: "📝",
    to: "paragraphs",
    gradient: "from-gray-500 to-gray-500",
  },
  {
    title: "Quản lý quản trị",
    desc: "Quản lý tài khoản quản trị viên và trạng thái",
    icon: "👤",
    to: "admins",
    gradient: "from-gray-500 to-gray-500",
  },
  {
    title: "Quản lý quyền",
    desc: "Phân quyền, role và kiểm soát truy cập",
    icon: "🔐",
    to: "permissions",
    gradient: "from-gray-500 to-gray-500",
  },
];
